import { AiOutlineArrowRight } from "react-icons/ai";
import BreadCrumbSection from "../../components/breadcrumb_section";
import { Anulicense } from "../../license";
import { Link } from "react-router-dom";

const BlogPages = () => {
  return (
    <div>
      <BreadCrumbSection page="Blog" />
      <section id="anuprint_blog_section" className="anuprint_blog">
        <div className="container mx-auto">
          <div className="block pt-10 pb-10">
            <div className="blog_wrapper container mx-auto px-4 py-10">
              <div className=" flex flex-wrap items-center justify-center gap-6">

                <div className="blog_card bg-white p-4 shadow rounded-md">
                  <div className="flex flex-col gap-5">
                    <div>
                      <img
                        src={Anulicense.blogImg1}
                        className="w-full block align-top rounded-md"
                        alt="Blog"
                      />
                    </div>
                    <div>
                      <h1 className="font-bold text-[24px]">
                        Top Printing Services in Mysore for Businesses and Startups
                      </h1>
                      <div className="text-ellipsis">
                        <p>
                          It’s frustrating, isn’t it? You plan an event or
                          launch a new product, rush to get your brochures or
                          business cards printed, and the final result looks
                          dull, misaligned, or worse — delayed! Many startups
                          and small businesses in Mysore face this exact
                          issue when they don’t choose the right printing
                          partner.
                        </p>
                      </div>
                      <Link
                        to={"/blog/top-printing-services"}
                        className="uppercase inline-flex items-center gap-2 text-blue-600 mt-4"
                      >
                        <AiOutlineArrowRight /> Continue Reading
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="blog_card bg-white p-4 shadow rounded-md">
                  <div className="flex flex-col gap-5">
                    <div>
                      <img
                        src={Anulicense.blogImg2}
                        className="w-full block align-top rounded-md"
                        alt="Blog"
                      />
                    </div>
                    <div>
                      <h1 className="font-bold text-[24px]">
                        Why Choose Local Printing Services in Mysore Over
                        Online Printers
                      </h1>
                      <p>
                        Ever ordered prints online, only to receive faded
                        colours, wrong paper, or a delivery delay when you
                        needed it urgently? You’re not alone. Many startups and
                        businesses in Mysore have faced this problem. You
                        spend money, wait days, and still don’t get what you
                        expected. The frustration is real.
                      </p>
                      <Link
                        to={"/blog/why-choose-local-printing"}
                        className="uppercase inline-flex items-center gap-2 text-blue-600 mt-4"
                      >
                        <AiOutlineArrowRight /> Continue Reading
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPages;
